import { io, type Socket } from 'socket.io-client';
import type { Ack, ClientToServerEvents, RoomSnapshot, ServerToClientEvents } from '@etown/shared';

export type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

/**
 * Erstellt die typisierte Socket.IO-Verbindung. Auth laeuft ueber das
 * httpOnly-Session-Cookie im Handshake (same-origin), daher keine Tokens
 * im JavaScript.
 */
export function createSocket(): AppSocket {
  return io({
    path: '/socket.io',
    autoConnect: false,
    // Transports bewusst NICHT auf ['websocket'] beschraenken: hinter einem
    // reinen HTTP/2-Proxy ohne WS-Upgrade faellt Socket.IO so automatisch auf
    // HTTP-Long-Polling zurueck (siehe docs/DEPLOYMENT-FIRMENPROXY.md).
    // Reconnect mit Backoff; nach Reconnect tritt der Client erneut bei
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
  });
}

/** Promise-Wrapper fuer room:join. */
export function joinRoom(socket: AppSocket, mapId: string): Promise<RoomSnapshot> {
  return new Promise((resolve, reject) => {
    socket.emit('room:join', { mapId }, (res: Ack<RoomSnapshot>) => {
      if (res.ok) resolve(res.data);
      else reject(new Error(res.error));
    });
  });
}
